module.exports = {
    stepone:'browse of all the cooperative business services, check  information and related reports of various media at any time',
    steptwo:'Customized market research and industry trends, focusing on more vertical insights accurately.',
    stepthree:'Personalized message management, account management, financial management, and help promote activities more conveniently.',
    stepfour:'Overview of the cost and delivery effect of various media advertisements, and quickly grasp the ROI during  delivery periods',
    stepfive:'More media resources and news updates, grasping the latest marketing trends.',
    jump:'Jump',
    next:'Next step',
    know:'I got it',
    homeTitle: "Home",
    aggregatorTitle:'Aggregator',
    aggregatorTitleMkt:'Aggregator MKT',
    localMediaTitle: "Local MKT",
    adn_service:'ADN Service',
    allviews:'Overview',
    kol_mkt: "KOL MKT",
    kol_mkt1: "KOL Data",
    kol_mkt2:'KOL MKT',
    havedel:'The file has been deleted',
    local_mkt:'Local MKT',
    appMkt:'App MKT',
    formaterror:'Upload fail：please check upload file Type：jpg、jpeg、png、gif、bmp、txt、doc、docx、ppt、pptx、pdf、rar、zip、mp4',
    market_analysis_rep:'Market Analysis Reports',
    aggregator_mkt:'Aggregator MKT',
    appAnalysisReports:'App Analysis Reports',
    // programmatic_mkt:'Programmatic MKT',
    programmatic_mkt:'Programmatic MKT',
    programmatic_mkt_manage:'Programmatic MKT(manage)',
    allcost:'All Media Cost',
    Updated:'Updated',
    NN:'No Notice',
    jianshe:'This page is under construction',
    working:'We’re working on it!',
    csud:'Copy success',
    NSR:'No Search Result',
    rs:'Related Searches',
    sh:'Search History',
    bh:'Back Home',
    item:'items',
    total:'Total',
    ND:'No Data',
    noauth:'Sorry, you are not authorized to access this page.',
    openfirst:'Please open the service first',
    fillinfi:'please fill in the mediaSouce of this data first.',
    moreadv:'Get more with your Yeahgrowth adviser:',
    nolimitfonts:'Please contact your BD to open the module service first',
    noau:'Opps , No permission',
    yadv:'Your personal adviser:',
    yhf:'You have found',
    rrt:'results related to',
    moredetail:'You can check the Media Introduction meanwhile',
    gome:'Media Source Introduction',
    newsno:"There is no data",
    items:'items',
    coverit:'please upload image',
    reserveone:'Please reserve at least one data.',
    moveSuccess:"move success",
    havetop:"It's already at the top",
    havebottom:"It's already at the bottom",
    errors:'system error',
    goodstaff:"Great stuff we've got it ready, they're on their way.",
    today:'Yesterday',
    psya:'Please select your AppName',
    psyp:'please select your platform',
    newUser:'New User',
    Retargeting:'Retargeting',
    revShare:'Rev Share',
    existed:'media source existed',
    existedcountry:'Countries under the same media resources cannot be the same',
    other:'Others',
    nodate:'Opps, no data',
    potsf:'Please open the service first',
    monthToDate:"Month till yesterday",
    Marketservice:'Consulting Services',
    Overview:'Overview',
    overallSpend:'Overall Spend',
    cost:"Spend",
    pleaseOpenTheServiceFirst:"Please open the service first",
    LocalMedia:'Local MKT',
    mediaCostTrendsInLast7Days:"Media Spend Trends in Last 7 Days",
    top5ProductsInLast7DaySpend:'Top 5 Products in Last 7 Days (Spend)',
    whatsNew:"What's New",
    viewMode:'VIEW MORE',
    saveok:"Save success",
    submitok:"Submit Success",
    compilited:'please complete table data',
    exhibitionWall:'Exhibition Wall',
    highQualityResources:"High Quality Resources",
    getAccessNow:'Get Access Now',
    itsunderconstruction:"It's under construction",
    dashboard:'Dashboard',
    influencer: 'KOL MKT',
    more: 'More',
    allNews: 'All News',
    activities: 'Activities',
    awards: 'Awards',
    allMessages: 'All Messages',
    taskReminder: 'Task Reminder',
    productUpdate: 'Product Update',
    resources: 'Resources',
    report: 'Report',
    viewAllNotifications: 'View all notifications',
    clickHereTip: 'For more details, please click here',
    howCanHelp: 'Hi，How can we help？',
    viewNow: 'View Now',
    viewAll: 'View All',
    operatingManuals: 'Operating Manuals',
    learnMore: 'Learn More',
    describeorSearchKeyword: 'Describe your question or search keyword',
    advertiserSetting:'Advertiser Setting',
    userSetting:'User Setting',
    others:'Marketing Services',
    Overseas:'Overseas',
    Europe:'Europe',
    North_American:'North American',
    South_American:'South American',
    Southeast_Asia:'Southeast Asia',
    the_Middle_East:'The Middle East',
    Africa:'Africa',
    India:'India',
    Indonesia:'Indonesia',
    Japan:'Japan',
    South_Korea:'South Korea',
    China:'China',
    zome:'Filter by area',
    fbp:'Filter by product',
    bangdan:'Top Apps Analysis',
    jingpin:'Competitive Product Analysis',
    savenews:'Save & Add New', 
    Generate:'Generate',
    KolTracking:'KOL Tracking',
    LocalMediaLift: 'Lift Media',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/home/en.js